module.exports = __webpack_public_path__ + "packs/media/images/Treffen-0b1922876d2f22e9e1621a1d2fa8c1cf.svg";